import React from 'react'; // eslint-disable-next-line
import Layout from '../../components/Layout';
import KYCRequests from './KYCRequests';
import WithdrawalRequests from './WithdrawalRequests';
import { useSearchParams } from 'react-router-dom';
import { Shield, Wallet, CheckCircle } from 'lucide-react';

const Approvals = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    const currentTab = searchParams.get('tab') || 'kyc';

    const tabs = [
        { id: 'kyc', label: 'KYC Approvals', icon: Shield },
        { id: 'withdrawals', label: 'Withdrawal Approvals', icon: Wallet },
    ];

    const handleTabChange = (tabId) => {
        setSearchParams({ tab: tabId });
    };

    return (
        <Layout>
            <div className="space-y-8 p-1 sm:p-2">
                <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
                    <div>
                        <h1 className="text-3xl sm:text-4xl font-black text-gray-900 tracking-tight flex items-center gap-3">
                            <CheckCircle className="text-blue-600" size={32} />
                            Pending Approvals
                        </h1>
                        <p className="text-gray-500 font-medium tracking-tight">System-wide verification and payout management</p>
                    </div>
                </div>

                {/* Tabs Navigation */}
                <div className="bg-white p-2 rounded-[2rem] shadow-sm border border-gray-100 flex flex-col sm:flex-row gap-2">
                    {tabs.map((tab) => {
                        const Icon = tab.icon;
                        return (
                            <button
                                key={tab.id}
                                onClick={() => handleTabChange(tab.id)}
                                className={`flex-1 flex items-center justify-center gap-3 px-8 py-4 rounded-[1.5rem] text-sm font-black uppercase tracking-widest transition-all ${currentTab === tab.id
                                    ? 'bg-gray-900 text-white shadow-xl shadow-gray-200 translate-y-[-2px]'
                                    : 'text-gray-400 hover:text-gray-600 hover:bg-gray-50'
                                    }`}
                            >
                                <Icon size={20} />
                                {tab.label}
                            </button>
                        );
                    })}
                </div>

                {/* Tab Content */}
                <div className="animate-fadeIn min-h-[600px]">
                    {currentTab === 'kyc' && (
                        <KYCRequests isEmbedded={true} />
                    )}
                    {currentTab === 'withdrawals' && (
                        <WithdrawalRequests isEmbedded={true} />
                    )}
                </div>
            </div>
            <style>{`
                @keyframes fadeIn {
                    from { opacity: 0; transform: translateY(10px); }
                    to { opacity: 1; transform: translateY(0); }
                }
                .animate-fadeIn {
                    animation: fadeIn 0.4s cubic-bezier(0.4, 0, 0.2, 1);
                }
            `}</style>
        </Layout>
    );
};

export default Approvals;
